export default {"src":"/_next/static/media/check.a6ffedeb.svg","height":24,"width":24};